import React from 'react'
import PropTypes from 'prop-types'
import Arrow from 'media/arrow-right.svg?svgr-webpack'

export default function ExternalLinkBlock({ links }) {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:gap-12">
      {links.map(({ id, background, image, link, linkColor, text }) => {
        return (
          <div
            key={id}
            className="relative mx-auto h-full w-full max-w-768 rounded-12 shadow-elevated transition lg:rounded-16"
            style={{ backgroundColor: background.hex }}
          >
            <div
              className="relative h-0 w-full overflow-hidden"
              style={{ paddingTop: '50%' }}
            >
              <img
                src={image.url}
                alt=""
                className="absolute left-1/2 top-1/2 w-3/5 -translate-x-1/2 -translate-y-1/2 transform"
              />
            </div>
            <div className="px-32 pb-32 text-center">
              <a
                className="fill-link group type-24 xl:type-28"
                href={link}
                target="_blank"
                rel="noreferrer"
                style={{ color: linkColor.hex }}
              >
                <Text content={text} />
              </a>
            </div>
          </div>
        )
      })}
    </div>
  )
}

ExternalLinkBlock.propTypes = {
  links: PropTypes.objectOf({
    image: PropTypes.object,
    text: PropTypes.string,
    link: PropTypes.string,
    background: PropTypes.object,
    linkColor: PropTypes.object,
  }),
}

function Text({ content }) {
  const wordsArray = content.trim().split(' ')
  const last = wordsArray.pop()

  return [
    wordsArray.join(' '),
    <span className="whitespace-nowrap" key="last">
      {` ${last}`}
      <span
        className={`
          ml-6 inline-flex h-24
          w-24
          origin-left transform rounded-full bg-transparent
          transition  group-hover:translate-x-1
          group-hover:bg-TypeConstant group-hover:text-Type lg:scale-125
        `}
      >
        <Arrow className="m-auto" />
      </span>
    </span>,
  ]
}
Text.propTypes = {
  content: PropTypes.string,
}
